const CONTROL_PLANE_URL = 'https://api.feel-app.com';
const CONTROL_PLANE_STAGING_URL = 'https://stg-api.feel-app.com';

let isStagingAPI = false;

export const setStagingControlPlane = (isStaging: boolean) => {
  isStagingAPI = isStaging;
};

const getAPIUrl = () => {
  return isStagingAPI ? CONTROL_PLANE_STAGING_URL : CONTROL_PLANE_URL;
};

export const getFecToken = async (roomNumber: string) => {
  let response = null;
  try {
    const url = `${getAPIUrl()}/api/v1/room-number-token/${roomNumber}`;
    response = await fetch(url);
  } catch (err) {
    throw new Error('Failed to get FEC token');
  }
  if (!response.ok) {
    throw new Error(`Failed to get FEC token (status ${response.status})`);
  }
  const json = await response.json();
  return json.fec_token;
};
